/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BonusAvailableBillTypesSaveReqVo
 */
export interface BonusAvailableBillTypesSaveReqVo {
    /**
     * 用户ID
     * @type {number}
     * @memberof BonusAvailableBillTypesSaveReqVo
     */
    userId: number;
    /**
     * 可用账单类型集合（billType数组；空集合=全部不可用）
     * @type {Array<number>}
     * @memberof BonusAvailableBillTypesSaveReqVo
     */
    billTypes: Array<number>;
}

/**
 * Check if a given object implements the BonusAvailableBillTypesSaveReqVo interface.
 */
export function instanceOfBonusAvailableBillTypesSaveReqVo(value: object): value is BonusAvailableBillTypesSaveReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('billTypes' in value) || value['billTypes'] === undefined) return false;
    return true;
}

export function BonusAvailableBillTypesSaveReqVoFromJSON(json: any): BonusAvailableBillTypesSaveReqVo {
    return BonusAvailableBillTypesSaveReqVoFromJSONTyped(json, false);
}

export function BonusAvailableBillTypesSaveReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusAvailableBillTypesSaveReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'billTypes': json['billTypes'],
    };
}

export function BonusAvailableBillTypesSaveReqVoToJSON(json: any): BonusAvailableBillTypesSaveReqVo {
    return BonusAvailableBillTypesSaveReqVoToJSONTyped(json, false);
}

export function BonusAvailableBillTypesSaveReqVoToJSONTyped(value?: BonusAvailableBillTypesSaveReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'billTypes': value['billTypes'],
    };
}

